import { useState, type FormEvent } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/daimb2roh653ivfvog80';

const interests = [
  '娱乐八卦',
  '网红动态',
  '影视综艺',
  '社会热议',
  '品牌风向',
  '情感生活',
];

export default function SubscribeForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const guardValue = String(formData.get('contact_alt') ?? '').trim();
    if (guardValue) {
      setStatus('success');
      setMessage('订阅成功，热点更新会第一时间送到你的邮箱。');
      form.reset();
      return;
    }

    setStatus('submitting');
    setMessage('');

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === 'contact_alt') return;
      const text = String(value).trim();
      if (!text) return;
      payload.append(key, text);
    });

    try {
      const response = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }

      const serverMessage =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMessage === 'string' && serverMessage.toLowerCase().includes('spam');
      const ok = response.ok && parsed?.code === 'OK' && !isSpam;

      if (ok) {
        setStatus('success');
        setMessage('订阅成功，热点更新会第一时间送到你的邮箱。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(
          typeof serverMessage === 'string' && serverMessage.trim() && !isSpam
            ? `订阅失败：${serverMessage}`
            : '订阅失败，请稍后再试一次。',
        );
      }
    } catch {
      setStatus('error');
      setMessage('网络好像有点问题，请稍后再试一次。');
    }
  };

  return (
    <form
      id="hotspot-subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <label htmlFor="subscribe-email" className="block text-xs text-foreground-600 mb-1.5">
            邮箱地址
          </label>
          <input
            id="subscribe-email"
            name="email"
            type="email"
            required
            autoComplete="email"
            placeholder="you@example.com"
            className="w-full h-11 px-3.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
          />
        </div>
        <div className="sm:w-44">
          <label htmlFor="subscribe-interest" className="block text-xs text-foreground-600 mb-1.5">
            关注方向
          </label>
          <select
            id="subscribe-interest"
            name="interest"
            defaultValue={interests[0]}
            className="w-full h-11 px-3 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 cursor-pointer"
          >
            {interests.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <div className="sm:pt-[22px]">
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="w-full sm:w-auto h-11 px-6 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 disabled:opacity-60 transition-colors cursor-pointer whitespace-nowrap"
          >
            {status === 'submitting' ? '提交中…' : '订阅热点'}
          </button>
        </div>
      </div>

      <input
        type="text"
        name="contact_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-guard-field"
      />

      <p
        aria-live="polite"
        className={`mt-3 text-xs min-h-[16px] ${
          status === 'error' ? 'text-primary-700' : 'text-accent-700'
        }`}
      >
        {message}
      </p>
      <p className="mt-1 text-xs text-foreground-500">
        我们只发送热点更新邮件，不会向第三方共享你的邮箱。
      </p>
    </form>
  );
}